import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

/**
 * Define la estructura esperada de la respuesta de error 'ProblemDetails' del backend.
 */
interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance: string;
}

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let summary = 'Error Inesperado';
        let detail = 'Ocurrió un error. Por favor, contacte al administrador.';

        if (error.error instanceof ErrorEvent) {
          // Error del lado del cliente o de red.
          detail = error.error.message;
        } else {
          // El backend devolvió un código de error.
          
          // Intenta parsear la respuesta como ProblemDetails.
          const problemDetails = error.error as ProblemDetails;

          if (problemDetails && problemDetails.title && problemDetails.detail) {
            summary = problemDetails.title;
            detail = problemDetails.detail;
          } else if (error.statusText) {
            // Si no es ProblemDetails, usa el texto de estado HTTP.
            summary = `Error ${error.status}`;
            detail = error.statusText;
          }
        }
        
        // Muestra el toast con el error.
        this.messageService.add({
          severity: 'error',
          summary: summary,
          detail: detail,
          life: 6000, // Un poco más de tiempo para errores
        });

        // Propaga el error para que otros manejadores puedan reaccionar.
        return throwError(() => error);
      })
    );
  }
} 